import { EMPTY_ARRAY_DATA } from '@common/constants';
import { SplitChar } from '@common/constants/general';

export const splitStringWeekdays = (weekdays?: string | null) => {
  if (!weekdays) return EMPTY_ARRAY_DATA;
  return weekdays.split(SplitChar.Semicolon);
};
